export const MatchmakingScreen = ({ matchmakingPlayers, cities, fakeNames, loggedInUser, selectedCharacter }) => {
  return (
    <div
      className="relative w-full max-w-md h-[100dvh] sm:h-[700px] mx-auto overflow-hidden bg-gradient-to-b from-slate-900 via-indigo-950 to-slate-900 shadow-2xl sm:rounded-3xl sm:border-8 sm:border-white select-none"
      data-testid="matchmaking-screen"
    >
      <div className="relative z-10 flex flex-col items-center h-full px-6 py-8">
        <h1 className="game-title text-3xl text-white mb-2" data-testid="matchmaking-title">
          Finding Players...
        </h1>
        <p className="text-white/50 text-sm mb-8" style={{ fontFamily: 'Nunito, sans-serif' }}>
          Searching for players around the world
        </p>

        {/* Spinning globe */}
        <div className="relative w-16 h-16 mb-8">
          <div className="w-16 h-16 rounded-full border-4 border-white/20 border-t-cyan-400"
            style={{ animation: 'spin 1s linear infinite' }} />
          <span className="absolute inset-0 flex items-center justify-center text-2xl">🌍</span>
        </div>

        {/* Player slots */}
        <div className="w-full space-y-3">
          {[0, 1, 2, 3].map((slot) => {
            const player = matchmakingPlayers[slot];
            return (
              <div
                key={slot}
                className="flex items-center gap-3 rounded-xl px-4 py-3 transition-all duration-500"
                style={{
                  background: player ? `linear-gradient(90deg, ${player.color}25, transparent)` : 'rgba(255,255,255,0.05)',
                  borderLeft: player ? `4px solid ${player.color}` : '4px solid rgba(255,255,255,0.1)',
                  opacity: player ? 1 : 0.4,
                  transform: player ? 'translateX(0)' : 'translateX(10px)',
                }}
                data-testid={`matchmaking-slot-${slot}`}
              >
                {player ? (
                  <>
                    <div className="w-10 h-10 rounded-full overflow-hidden border-2 flex-shrink-0"
                      style={{ borderColor: player.color }}>
                      <img src={player.png} alt="" className="w-full h-full object-contain" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-white font-bold text-sm truncate" style={{ fontFamily: 'Fredoka, sans-serif' }}>
                        {player.isPlayer ? `${loggedInUser?.name || player.name} (You)` : (fakeNames[slot] || player.name)}
                        <span className="text-white/40 font-normal text-xs ml-2">{cities[slot] || ''}</span>
                      </div>
                    </div>
                    <span className="text-green-400 text-xs font-bold">READY</span>
                  </>
                ) : (
                  <>
                    <div className="w-10 h-10 rounded-full bg-white/10 flex-shrink-0 animate-pulse" />
                    <div className="flex-1">
                      <div className="text-white/30 text-sm" style={{ fontFamily: 'Nunito, sans-serif' }}>
                        Searching...
                      </div>
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>

        <p className="text-white/40 text-xs mt-6 animate-pulse" style={{ fontFamily: 'Nunito, sans-serif' }}>
          {matchmakingPlayers.length < 4
            ? `${matchmakingPlayers.length}/4 players found`
            : 'All players found! Starting game...'
          }
        </p>
      </div>
    </div>
  );
};
